import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider_enlarge_white",
  "use": "icon-slider_enlarge_white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-slider_enlarge_white\">\n<path d=\"M6 12H18\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M12 6L12 18\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol